export default {
  inceptionv1: {
    conv2d0: 64,
    conv2d1: 64,
    conv2d2: 192,
    head0_bottleneck: 128,
    head1_bottleneck: 128,
    mixed3a: 256,
    mixed3b: 480,
    mixed4a: 508,
    mixed4b: 512,
    mixed4c: 512,
    mixed4d: 528,
    mixed4e: 832,
    mixed5a: 832,
    mixed5b: 1024,
  },
  alexnet: {
    conv1_1: 96,
    conv2_1: 256,
    conv3_1: 384,
  },
}
